import { createSlice, current } from '@reduxjs/toolkit';
import { initialState } from '../../../data/billing/billingTool/initialState.billingTool.data';
import {
  getHistory as getHistoryAPI,
  getBillingData as getBillingDataAPI,
  fetchBillingStatus as fetchBillingStatusAPI,
  searchCpiByCountry as searchCpiByCountryAPI,
  fetchBillingContractDetails as fetchBillingContractDetailsAPI,
  fetchBillingGridData as fetchBillingGridDataAPI,
  fetchBillingDetailsTabData as fetchBillingDetailsTabDataAPI,
  fetchBillingNoteData as fetchBillingNoteDataAPI,
  fetchBillingLineDdData as fetchBillingLineDdDataAPI,
  addBillingNoteLineHeader as addBillingNoteLineHeaderAPI,
  regenerateBill as regenerateBillAPI,
  setApprovBills as setApprovBillsAPI,
} from '../../../apis/billingAPI';

import { ACTIONS_BILLING } from '../../../constants/actionCreator';
import { BILLING } from '../../../constants';
import { createAsyncThunkWrapper } from '../../../services/common/asyncThunkWrapper';
import { convertToUTC, globalDateFormat } from '../../../utils/common';

//API for history tab data
export const getHistory = createAsyncThunkWrapper(
  ACTIONS_BILLING.HISTORYTAB,
  getHistoryAPI
);

export const fetchBillingData = createAsyncThunkWrapper(
  ACTIONS_BILLING.BILLING_SEARCH,
  getBillingDataAPI
);

export const getBillingStatus = createAsyncThunkWrapper(
  ACTIONS_BILLING.BILLING_STATUS,
  fetchBillingStatusAPI
);

export const setApprovBills = createAsyncThunkWrapper(
  ACTIONS_BILLING.APPROVE_BILLLS,
  setApprovBillsAPI
);

//cpi setup & updates apis
//search cpi by country
export const searchCpiByCountry = createAsyncThunkWrapper(
  ACTIONS_BILLING.SEARCHCPIBYCOUNTRY,
  searchCpiByCountryAPI
);

export const fetchBlillingContractDetails = createAsyncThunkWrapper(
  ACTIONS_BILLING.FETCH_BILLING_CONTRACT_DETAILS,
  fetchBillingContractDetailsAPI
);

export const fetchBlillingToolGridData = createAsyncThunkWrapper(
  ACTIONS_BILLING.FETCH_BILLING_TOOL_GRID_DATA,
  fetchBillingGridDataAPI
);

//Billing Details Tab Data
export const fetchBillingDetailsTabData = createAsyncThunkWrapper(
  ACTIONS_BILLING.FETCH_BILLING_DETAILS_Tab_DATA,
  fetchBillingDetailsTabDataAPI
);

export const fetchBillingNoteHeaderData = createAsyncThunkWrapper(
  ACTIONS_BILLING.FETCH_BILLING_TOOL_NOTE_HEADER_DATA,
  fetchBillingNoteDataAPI
);

export const fetchBillingNoteLineData = createAsyncThunkWrapper(
  ACTIONS_BILLING.FETCH_BILLING_TOOL_NOTE_LINE_DATA,
  fetchBillingNoteDataAPI
);

export const fetchBillingLineDdData = createAsyncThunkWrapper(
  ACTIONS_BILLING.FETCH_BILLING_LINE_DD_DATA,
  fetchBillingLineDdDataAPI
);

export const addBillingNoteLineHeader = createAsyncThunkWrapper(
  ACTIONS_BILLING.ADD_BILING_NOTE_LINE_HEADER,
  addBillingNoteLineHeaderAPI
);

export const addBillingNoteLineHeaders = createAsyncThunkWrapper(
  ACTIONS_BILLING.ADD_BILING_NOTE_LINE_HEADERS,
  addBillingNoteLineHeaderAPI
);

export const regenerateBill = createAsyncThunkWrapper(
  ACTIONS_BILLING.REGENRATE_BILL,
  regenerateBillAPI
);

// Reducer and Actions
const billingToolSlice = createSlice({
  name: BILLING.billingTool.billSliceName,
  initialState,
  reducers: {
    handleReset: () => initialState,
    handlesetSelectedTabValue: (state, action) => {
      state.selectededTabValue = action?.payload;
    },
    handleSelectionGridData: (state, action) => {
      if (action?.payload.length > 0) {
        if (state.isCustomerNumberClicked) {
          state.billingSelectedGridData = action?.payload[0] || null;
        } else {
          state.selectedRowData = action?.payload;
        }
        state.billingArray[state.currentPage ? state.currentPage : 1] =
          action?.payload;
      }
    },
    resetGridValues: (state) => {
      state.billingSearchData = initialState.billingSearchData;
      state.selectedRowData = initialState.selectedRowData;
      state.billingSearchCount = initialState.billingSearchCount;
      state.isCustomerNumberClicked = initialState.isCustomerNumberClicked;
      state.isReset = true;
      if (state.isReset) {
        state.billingArray = [];
      }
    },
    settingBillingSelectedGridData: (state, action) => {
      state.billingSelectedGridData = action?.payload || null;
      state.isCustomerNumberClicked = true;
    },

    settingNoteHeaderData: (state, action) => {
      state.billingToolNoteHeaderData = action?.payload;
    },

    settingNoteLineData: (state, action) => {
      state.billingToolNoteLineData = action?.payload;
    },

    settingFromCustomer: (state, action) => {
      state.isBillingFromCustomer = action?.payload;
    },

    reSettingBillingSearchCount: (state) => {
      state.billingSearchCount = initialState.billingSearchCount;
    },

    settingPopupStatus: (state, action) => {
      state.isPopupOpen = action?.payload;
    },
    setIsRegeneratedFlag: (state, action) => {
      state.isRegenerated = action?.payload;
    },
    setRedicrectToBillTool: (state, action) => {
      state.redirectToBillTool = action?.payload;
    },
    setApproveBillStatus: (state, action) => {
      state.approveBillStatus = action?.payload;
    },
    addBillData: (state, action) => {
      state.billingArray[action?.payload?.currentPage] = action?.payload?.data;
    },

    handleBillArray: (state) => {
      state.billingArray = [];
    },
    handleCurrentPage: (state, action) => {
      state.currentPage = action?.payload;
    },
    handleIsReset: (state, action) => {
      state.isReset = action?.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      //history tab
      .addCase(getHistory.pending, (state) => {
        state.historyLoading = true;
        state.historyData = [];
      })
      .addCase(getHistory.fulfilled, (state, action) => {
        state.historyLoading = false;
        state.historyData = action?.payload?.history;
        state.totalCount = action?.payload?.totalRecords;
      })
      .addCase(getHistory.rejected, (state) => {
        state.historyLoading = false;
        state.historyData = [];
      })

      .addCase(fetchBillingData.pending, (state) => {
        state.billingSearchLoading = true;
        state.billingSearchData = [];
        state.billingSearchCount = 0;
      })
      .addCase(fetchBillingData.fulfilled, (state, action) => {
        state.billingSearchLoading = false;
        state.billingSearchData = action?.payload?.pendingBills;
        state.billingSearchCount = action?.payload?.totalRecords
          ? action?.payload?.totalRecords
          : 0;
      })
      .addCase(fetchBillingData.rejected, (state) => {
        state.billingSearchLoading = false;
        state.billingSearchData = [];
        state.billingSearchCount = 0;
      })

      .addCase(getBillingStatus.pending, (state) => {
        state.billingStatusLoading = true;
        state.billingStatusData = [];
      })
      .addCase(getBillingStatus.fulfilled, (state, action) => {
        state.billingStatusLoading = false;
        const onptions = action?.payload;
        onptions.splice(0, 0, {
          billStatusId: 0,
          billStatusName: 'Any',
        });
        state.billingStatusData = onptions;
      })
      .addCase(getBillingStatus.rejected, (state) => {
        state.billingStatusLoading = false;
        state.billingStatusData = [];
      })

      .addCase(searchCpiByCountry.pending, (state) => {
        state.billingStatusLoading = true;
        state.billingStatusData = [];
      })
      .addCase(searchCpiByCountry.fulfilled, (state, action) => {
        state.billingStatusLoading = false;
        state.billingStatusData = action?.payload;
      })
      .addCase(searchCpiByCountry.rejected, (state) => {
        state.billingStatusLoading = false;
        state.billingStatusData = [];
      })

      .addCase(setApprovBills.pending, (state) => {
        state.approveBillLoading = true;
        state.approveBillStatus = null;
      })
      .addCase(setApprovBills.fulfilled, (state, action) => {
        state.approveBillLoading = false;
        let billStatus =
          action?.meta?.arg[0]?.billStatusId === 1
            ? BILLING.waitingForApproval
            : action?.meta?.arg[0]?.billStatusId === 2
            ? BILLING.approvedToBilled
            : BILLING.billed;
        if (state.billingSelectedGridData !== null) {
          state.billingSelectedGridData['billingStatus'] = billStatus;
          state.billingSelectedGridData['billingStatusId'] =
            action?.meta?.arg[0]?.billStatusId;
        }
        state.approveBillStatus = true;
      })
      .addCase(setApprovBills.rejected, (state) => {
        state.approveBillLoading = false;
        state.approveBillStatus = false;
      })

      .addCase(fetchBlillingContractDetails.pending, (state) => {
        state.contractStatus = true;
        state.billingContractDetails = [];
      })
      .addCase(fetchBlillingContractDetails.fulfilled, (state, action) => {
        state.contractStatus = false;
        state.billingContractDetails = action?.payload;
      })
      .addCase(fetchBlillingContractDetails.rejected, (state) => {
        state.contractStatus = false;
        state.billingContractDetails = [];
      })

      .addCase(fetchBlillingToolGridData.pending, (state) => {
        state.billingToolGridDataLoader = null;
        state.billingToolGridData = [];
        state.billingToolGridDataCount = 0;
      })
      .addCase(fetchBlillingToolGridData.fulfilled, (state, action) => {
        state.billingToolGridDataLoader = true;
        state.billingToolGridData = action?.payload?.billData || [];
        state.billingToolGridDataCount = action?.payload?.totalRecords || 0;
      })
      .addCase(fetchBlillingToolGridData.rejected, (state) => {
        state.billingToolGridDataLoader = true;
        state.billingToolGridData = [];
        state.billingToolGridDataCount = 0;
      })

      .addCase(fetchBillingNoteHeaderData.pending, (state) => {
        state.billingToolNoteHeaderDataLoader = true;
        state.billingToolNoteHeaderData = [];
        state.billingToolNoteHeaderDataCount = 0;
      })
      .addCase(fetchBillingNoteHeaderData.fulfilled, (state, action) => {
        state.billingToolNoteHeaderDataLoader = false;
        state.billingToolNoteHeaderData = action?.payload?.notes;
        state.billingToolNoteHeaderDataCount = action?.payload?.totalRecords;
      })
      .addCase(fetchBillingNoteHeaderData.rejected, (state) => {
        state.billingToolNoteHeaderDataLoader = false;
        state.billingToolNoteHeaderData = [];
        state.billingToolNoteHeaderDataCount = 0;
      })

      .addCase(fetchBillingNoteLineData.pending, (state) => {
        state.billingToolNoteLineDataLoader = true;
        state.billingToolNoteLineData = [];
        state.billingToolNoteLineDataCount = 0;
      })
      .addCase(fetchBillingNoteLineData.fulfilled, (state, action) => {
        state.billingToolNoteLineDataLoader = false;
        state.billingToolNoteLineData = action?.payload?.notes;
        state.billingToolNoteLineDataCount = action?.payload?.totalRecords;
      })
      .addCase(fetchBillingNoteLineData.rejected, (state) => {
        state.billingToolNoteLineDataLoader = false;
        state.billingToolNoteLineData = [];
        state.billingToolNoteLineDataCount = 0;
      })

      .addCase(fetchBillingLineDdData.pending, (state) => {
        state.billingToolNoteLineDdData = [];
      })
      .addCase(fetchBillingLineDdData.fulfilled, (state, action) => {
        state.billingToolNoteLineDdData = action?.payload;
      })
      .addCase(fetchBillingLineDdData.rejected, (state) => {
        state.billingToolNoteLineDdData = [];
      })

      .addCase(addBillingNoteLineHeader.pending, (state) => {
        state.billingNoteHeaderLineSuccess.create = false;
        state.billingNoteHeaderLineSuccess.update = false;
      })
      .addCase(addBillingNoteLineHeader.fulfilled, (state, action) => {
        state.billingNoteHeaderLineSuccess.create = action?.payload;
      })
      .addCase(addBillingNoteLineHeader.rejected, (state) => {
        state.billingNoteHeaderLineSuccess.create = false;
        state.billingNoteHeaderLineSuccess.update = false;
      })

      .addCase(addBillingNoteLineHeaders.pending, (state) => {
        state.billingNoteHeaderLineSuccessLine.create = false;
        state.billingNoteHeaderLineSuccessLine.update = false;
      })
      .addCase(addBillingNoteLineHeaders.fulfilled, (state, action) => {
        state.billingNoteHeaderLineSuccessLine.create = action?.payload;
      })
      .addCase(addBillingNoteLineHeaders.rejected, (state) => {
        state.billingNoteHeaderLineSuccessLine.create = false;
        state.billingNoteHeaderLineSuccessLine.update = false;
      })

      .addCase(regenerateBill.pending, (state) => {
        state.regenerateBillLoading = true;
        state.isRegenerated = false;
      })
      .addCase(regenerateBill.fulfilled, (state, action) => {
        state.regenerateBillLoading = false;
        state.isRegenerated = action?.payload;
      })
      .addCase(regenerateBill.rejected, (state) => {
        state.regenerateBillLoading = false;
        state.isRegenerated = false;
      })

      .addCase(fetchBillingDetailsTabData.pending, (state) => {
        state.isBillingDetailsTabData = null;
        state.billingDetailsTabData = [];
        state.billingDetailsTabCount = 0;
      })
      .addCase(fetchBillingDetailsTabData.fulfilled, (state, action) => {
        state.isBillingDetailsTabData =
          action?.payload?.billDetails?.length === 0;
        state.billingDetailsTabData = action?.payload?.billDetails;
        state.billingDetailsTabCount = action?.payload?.totalRecords;
      })
      .addCase(fetchBillingDetailsTabData.rejected, (state) => {
        state.isBillingDetailsTabData = true;
        state.billingDetailsTabData = [];
        state.billingDetailsTabCount = 0;
      });
  },
});

export const {
  handlesetSelectedTabValue,
  resetGridValues,
  handleSelectionGridData,
  settingBillingSelectedGridData,
  handleReset,
  settingNoteHeaderData,
  settingNoteLineData,
  settingFromCustomer,
  reSettingBillingSearchCount,
  settingPopupStatus,
  setIsRegeneratedFlag,
  setRedicrectToBillTool,
  setApproveBillStatus,
  addBillData,
  handleBillArray,
  handleCurrentPage,
  handleIsReset,
} = billingToolSlice.actions;
export default billingToolSlice.reducer;
